import React from "react";
import { Line } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Box from "@mui/material/Box";
import { MyHrPayrollLineChartPlugin } from "my-hr/components";

type PayrollDataItem = {
  month: string;
  netWage: number;
};

interface MyHrPayrollLineChartProps {
  data: PayrollDataItem[];
}

export const MyHrPayrollLineChart: React.FC<MyHrPayrollLineChartProps> = ({
  data,
}) => {
  const { i18n } = useTranslation();

  let labels: string[] = [];
  let chartData: number[] = [];
  let maxValue = 0;

  if (data) {
    data.forEach((item) => {
      const monthName = moment(`2020-${item.month}`)
        .locale(i18n.language)
        .format("MMM")
        .toUpperCase()
        .replace(".", "");
      labels.push(monthName);
      chartData.push(item.netWage || 0);
      maxValue = Math.max(maxValue, item.netWage);
    });
  }

  return (
    <Box height="280px" marginTop="16px">
      <Line
        data={{
          labels,
          datasets: [
            {
              label: "Net salary:",
              data: chartData,
              backgroundColor: "#cc0033",
              borderColor: "#cc0033",
              borderWidth: 3,
              pointBackgroundColor: "#cc0033",
              pointHoverBackgroundColor: "#cc0033",
              pointBorderColor: "#fff",
              pointHoverBorderColor: "#fff",
              pointBorderWidth: 3,
              fill: true,
            },
          ],
        }}
        plugins={[MyHrPayrollLineChartPlugin]}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: { enabled: false },
          },
          layout: {
            padding: {
              top: 32,
              left: 32,
              right: 32,
            },
          },
          elements: {
            point: {
              radius: 6,
              borderWidth: 3,
              hoverRadius: 8,
              hoverBorderWidth: 2,
              hitRadius: 60,
            },
            line: {
              tension: 0,
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
                tickLength: 18,
              },
              ticks: {
                color: "#fff",
                font: {
                  size: 14,
                },
                padding: 8,
              },
            },
            y: {
              display: false,
              min: 0,
              max: maxValue + maxValue * 0.3,
            },
          },
        }}
      />
    </Box>
  );
};

export default MyHrPayrollLineChart;
